<template>
	<div class="s-gray-bg p-user-select" style="overflow:scroll; ">

		<div style="width:100%;" class="p-margin-top20">
			<!--<div>{{  returnDataBP  }}</div>-->
			<!--血压-->
			<!-- <div class="p-margin30 p-white-bg p-radius20 p-black p-margin-top10">
				<div class="p-margin30 p-padding-bottom20 p-padding-top20">
					<div class="p-space-between p-box-center-y">

						<span class="p-color1 p-font1" style="width: 33%;text-align: center;">用户</span>
						<span class="p-color1 p-font1" style="width: 33%;text-align: center;">性别</span>
						<span class="p-color1 p-font1" style="width: 33%;text-align: center;">年龄</span>
					</div>
					<div class="p-space-between p-box-center-y p-padding-top10">

						<span class="p-color3 p-font1" style="width: 33%;text-align: center;">郭学师</span>
						<span class="p-color3 p-font1" style="width: 33%;text-align: center;">男</span>
						<span class="p-color3 p-font1" style="width: 33%;text-align: center;">18</span>

					</div>
				</div>
			</div> -->
		</div>


		<div class="p-margin30 p-white-bg p-radius20 p-black p-margin-top20">
			<div class="p-margin30 p-white-bg p-radius20 p-black p-margin-top10" style="height: 5rem;">
				<img src="../assets/img/head_defualt.png"
					style="width: 2rem;height: 2rem;float: left;margin-top: 1.5rem;margin-right: 1rem;" />
				<img src="../assets/img/arrow_gray_right.png" style="float: right;margin-top: 2rem;" />
				<div style="padding-top: 1rem;">
					<span class="p-color1 p-font1">{{nibpReportDetailData.docfullname}}</span>
					<span class="p-color3 p-font0-8" style="margin-left: 0.5rem;margin-top: 0.2rem;">{{ $t('measure.explainDoctor') }}</span>
				</div>
				<div style="padding-top: 0.5rem;">
					<span class="p-color3 p-font0-8">{{nibpReportDetailData.hospitalname}}</span>
					<span class="p-color3 p-font0-8" style="margin-left: 0.5rem;">{{nibpReportDetailData.practitle}}</span>
				</div>


			</div>
		</div>

		<div class="p-box-center">
			<div style="width:100%;">

				<!--<div>{{  returnDataBP  }}</div>-->
				<!--血压-->
				<div class="p-margin30 p-white-bg p-radius20 p-black p-margin-top10">
					<div class="p-margin30 ">
						<div class="p-box-center-y p-space-between p-margin-top20"
							style="line-height:2.1rem; font-size:2.1rem;">
							<div class="p-line-height2 p-font0-8 p-color1 p-padding-top20">
								<div>
									{{$t('measure.bloodPressureAvgSys')}}
									<span v-if="returnDataBP.y2>0"
										class="p-font1 p-bold p-padding-left10 p-padding-right10">
										<span >{{ returnDataBP.y2 | yAxisCompute2(0,200,canvasHeight)  }}</span>
									</span>
									<span v-else class="p-font1 p-bold p-padding-left10 p-padding-right10">{{nibpReportDetailData.avgsys}}</span>
									<span class="p-color4">{{$t('measure.mmHg')}}</span>
								</div>
								<div>
									{{$t('measure.bloodPressureAvgDia')}}
									<span v-if="returnDataBP.y>0"
										class="p-font1 p-bold p-padding-left10 p-padding-right10">
										<span >{{ returnDataBP.y | yAxisCompute2(0,200,canvasHeight)  }}</span>
									</span>
									<span v-else class="p-font1 p-bold p-padding-left10 p-padding-right10">{{nibpReportDetailData.avgdia}}</span>
									<span class="p-color4">{{$t('measure.mmHg')}}</span>
								</div>
							</div>


							<div class="p-line-height2 p-font0-8 p-color1 p-padding-top20">
							<div>
									{{ time(nibpReportDetailData.sts).format('YYYY.MM.DD')+'-'+time(nibpReportDetailData.ets).format('YYYY.MM.DD')   }}
							</div>
							<div>
								<div class="p-inline-block p-radius50 p-margin-right10"
									:style="`width:${ radiusNum  }px; height:${ radiusNum  }px; background:${  colorArr[3]  };`">
								</div>
								{{$t('measure.bloodPressureSys')}}
								
								<div class="p-inline-block p-radius50 p-margin-right10" style="margin-left:30px;"
									:style="`width:${ radiusNum  }px; height:${ radiusNum  }px;  background:${  colorArr[1]  };`">
								</div>
								{{$t('measure.bloodPressureDia')}}
								</div>
							</div>
						</div>


						<div class="p-box-center p-margin-top20"
							:style="`height:${  canvasHeight+parseInt(canvasPadding[2])  }px;`">
							<!--
		                        血压图表
		                        :min-axis-space="20"
		                    -->
							<pillarNibpReport ref="BPPillar" v-if="BPCanvasOnoff"
								:type="'gradientLine' "
								:new-time.sync="returnTime.newTime" :width="canvasWidth" :height="canvasHeight"
								:line-width="3"
								:xAxisStrs="nibpReportPillardates"
								:padding="canvasPadding" :x-axis="7"
								:y-axis="[0,50,100,150,200]" :dots="BPDots" @sendData="sendDataBP"
								:axios-color="colorArr[3]" :btn-color="colorArr[1]"
								:color-arr="[colorArr[0],colorArr[1],colorArr[0],colorArr[3]]">
								<template v-slot:default>
									{{ returnDataBP.y2 | yAxisCompute2(0,200,canvasHeight)  }}
									{{ returnDataBP.y>0 ? '/' : ' ' }}
									{{ returnDataBP.y | yAxisCompute2(0,200,canvasHeight)  }}
								</template>
								<!-- <template v-else v-slot:default>
									{{ returnDataBP.y3 | yAxisCompute2(0,200,canvasHeight)  }}{{ returnDataBP.y>0 ? '-' : ' ' }}{{ returnDataBP.y4 | yAxisCompute2(0,200,canvasHeight)  }}
									{{ returnDataBP.y>0 ? '/' : ' ' }}
									{{ returnDataBP.y | yAxisCompute2(0,200,canvasHeight)  }}{{ returnDataBP.y>0 ? '-' : ' ' }}{{ returnDataBP.y2 | yAxisCompute2(0,200,canvasHeight)  }}
								</template> -->
							</pillarNibpReport>


						</div>
					</div>
					<div class="p-padding30 p-padding-top p-padding-bottom10" >
						<span class="p-line-height1 p-font1 p-black ">{{$t('measure.evaluate')}}</span>
					</div>
					<div class="p-padding30 p-padding-top10 p-padding-bottom10">
						<span
							class="p-line-height1-4 p-font0-8 p-color3 ">{{nibpReportDetailData.evaltext}}</span>
					</div>
					<div class="p-padding30 p-padding-top10 p-padding-bottom30" style="">
						<span
							class="p-line-height1 p-font0-8 p-color3 " style="float: right;margin-left: 0.5rem;">{{ time(nibpReportDetailData.evaldate).format('YYYY年MM月DD日 HH:mm')  }}</span>
						<span
							class="p-line-height1 p-font0-8 p-color3 " style="float: right;"></span>
					</div>
				</div>

			</div>
		</div>

		<div class="p-margin30 p-height-auto p-white-bg p-radius20 p-line-height2 p-font0-8 p-red p-margin-top30">
			<div class="p-padding30 p-padding-top30 p-padding-bottom10" style="">
				<span class="p-line-height1 p-font1-1 p-black p-bold">{{ $t('measure.bloodPressureProtectAdvice') }}</span>
			</div>
			<div class="p-padding30 p-padding-top10 p-padding-bottom30" style="">
				<span
					class="p-line-height1-4 p-font0-6 p-color3 ">{{nibpReportDetailData.suggestion}}</span>
			</div>
		</div>

	<div class="p-margin30 p-height-auto p-white-bg p-radius20 p-line-height1-4 p-font0-8 p-red p-margin-top30">
			<div class="p-padding30 p-padding-top30 p-padding-bottom10" style="height: 2.2rem;">
				<span class="p-line-height1 p-font1-1 p-black p-bold">{{$t('measure.bloodPressureStatistics')}}</span>
				<span class="p-line-height1 p-font0-8 "
					style="float: right;text-align: right;width: 20%;margin-top: 0.5rem;"
					:style="`color:${  colorArr[4]  }`"
					@click="switchTabStatus(3)">{{allNibpStatisticsShowAll?$t('common.packUp'):$t('common.showAll')}}</span>
				<span v-if="!allNibpStatisticsShowAll" style="float: right;">
					<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem;"
						:style="{backgroundColor:nibpReportDetailDataColor.allNibpStatisticsColor}">{{nibpReportDetailDataColor.allNibpStatisticsColor=='red'?$t('common.abnormal'):$t('common.normal')}}</span>
				</span>
			</div>
			<div v-if="allNibpStatisticsShowAll" class="p-font0-8">
				<div class="p-color3 p-font0-8 p-padding30">{{$t('measure.bloodPressureAverage')}}</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4" style="margin-left: 0.5rem;">{{nibpReportDetailData.avgsys}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysStatusColor}">{{nibpReportDetailData.avgsysstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：&lt;130 mmHg</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDia')}}</span>
						<span class="p-color1 p-font1-4" style="margin-left: 0.5rem;">{{nibpReportDetailData.avgdia}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaStatusColor}">{{nibpReportDetailData.avgdiastatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：&lt;85 mmHg</span>
				</div>
				<div class="p-padding30 p-color4 p-margin-bottom10 p-margin-left20 p-margin-right20 p-margin-top20"
					style="line-height:2rem; border-top:1px solid #999999;width: auto;">
				</div>
	
				<div class="p-color3 p-font0-8 p-padding30 p-padding-top20">{{$t('common.minValue')}}-{{$t('common.maxValue')}}</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.minsys +'-'+nibpReportDetailData.maxsys}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.maxMinSysStatusColor}">{{nibpReportDetailData.maxminsysstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：&lt;130 mmHg</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.mindia +'-'+nibpReportDetailData.maxdia}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.maxMinDiaStatusColor}">{{nibpReportDetailData.maxmindiastatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：&lt;85 mmHg</span>
				</div>
	
				<div class="p-padding30 p-color4 p-margin-bottom10 p-margin-left20 p-margin-right20 p-margin-top20"
					style="line-height:2rem; border-top:1px solid #999999;width: auto;">
				</div>
	
				<div class="p-color3 p-font0-8 p-padding30 p-padding-top20">{{$t('measure.bloodPressureLoadValue')}}</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysload24h}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysLoad24hStatusColor}">{{nibpReportDetailData.sysload24hstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.diaload24h}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaLoad24hStatusColor}">{{nibpReportDetailData.diaload24hstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDaySys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysloaddaytime}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysLoadDayTimeStatusColor}">{{nibpReportDetailData.sysloaddaytimestatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDayDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.diaLoaddaytime}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaLoadDayTimeStatusColor}">{{nibpReportDetailData.dialoaddaytimestatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureNightSys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysloadnight}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysLoadNightStatusColor}">{{nibpReportDetailData.sysloadnightstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureNightDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.dialoadnight}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaLoadNightStatusColor}">{{nibpReportDetailData.dialoadnightstatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≤40% </span>
				</div>
	
	
				<div class="p-padding30 p-color4 p-margin-bottom10 p-margin-left20 p-margin-right20 p-margin-top20"
					style="line-height:2rem; border-top:1px solid #999999;width: auto;">
				</div>
	
				<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-color3 p-font0-8 p-padding30 p-padding-top20">{{$t('measure.bloodPressureNightDropRate')}}</div>
				<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4" style="margin-left: 0.5rem;">{{nibpReportDetailData.nightsysdecrate}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.nightSysDecRateStatusColor}">{{nibpReportDetailData.nightsysdecratestatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
					<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：10%≤{{$t('measure.bloodPressureSys')}}≤ 20% </span>
				</div>
					<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDia')}}</span>
						<span class="p-color1 p-font1-4" style="margin-left: 0.5rem;">{{nibpReportDetailData.nightdiadecrate}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.nightDiaDecRateStatusColor}">{{nibpReportDetailData.nightdiadecratestatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
					<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：10%≤{{$t('measure.bloodPressureDia')}}≤ 20%</span>
				</div>
	
					<div v-if="(nibpReportDetailData.nightDiaDecRate!=0)" class="p-padding30 p-color4 p-margin-bottom10 p-margin-left20 p-margin-right20 p-margin-top20"
					style="line-height:2rem; border-top:1px solid #999999;width: auto;">
				</div>
	
				<div class="p-color3 p-font0-8 p-padding30 p-padding-top20">{{$t('measure.bloodPressureMeanArterialPressureAll')}}</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureMeanArterialPressure')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.avgdongmai}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.avgDongMaiStatusColor}">{{nibpReportDetailData.avgdongmaistatus==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:70≤{{$t('measure.bloodPressureMeanArterialPressure')}}≤105(mmHg)</span>
				</div>
	
				<div class="p-padding30 p-color4 p-margin-bottom10 p-margin-left20 p-margin-right20 p-margin-top20"
					style="line-height:2rem; border-top:1px solid #999999;width: auto;">
				</div>
	
				<div class="p-color3 p-font0-8 p-padding30 p-padding-top20">{{$t('measure.bloodPressureCoefficientVariation')}}</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysbianyixs24h}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysCv24hStatusColor }">{{nibpReportDetailData.sbyxs24hstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;16%</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.diabianyixs24h}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaCv24hStatusColor }">{{nibpReportDetailData.dbyxs24hstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;24%</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDaySys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysbianyixsdaytime}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysCvDayTimeStatusColor}">{{nibpReportDetailData.sbyxsdtstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;15%</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureDayDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.diabianyixsdaytime}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaCvDayTimeStatusColor}">{{nibpReportDetailData.dbyxsdtstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;22%</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureNightSys')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.sysbianyixsnight}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.sysCvNightStatusColor }">{{nibpReportDetailData.sbyxsnstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;13%</span>
				</div>
				<div class="p-padding30">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureNightDia')}}</span>
						<span class="p-color1 p-font1-4"
							style="margin-left: 0.5rem;">{{nibpReportDetailData.diabianyixsnight}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">%</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20" style="color:white;padding: 0.2rem 1rem 0.2rem 1rem;"
							:style="{backgroundColor:nibpReportDetailDataColor.diaCvNightStatusColor}">{{nibpReportDetailData.dbyxsnstatus ==1?$t('common.abnormal'):$t('common.normal')}}</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}:&lt;18%</span>
				</div>
				<!-- <div class="p-padding30 p-color4"
					style="line-height:2rem; border-top:1px solid #999999;margin: 0 1.5rem;width: auto;">
				</div>
				<div class="p-color3 p-font0-8 p-padding30 p-padding-top20">晨峰血压（平均值）</div>
				<div class="p-padding30" style="padding-top:0.5rem ;">
					<span>
						<span class="p-color1 p-font0-8">{{$t('measure.bloodPressureSys')}}</span>
						<span class="p-color1 p-font1-4" style="margin-left: 0.5rem;">{{}}</span>
						<span class="p-color4 p-font0-8" style="margin-left: 0.5rem;">mmHg</span>
					</span>
					<span style="float: right;margin-top: 1rem;">
						<span class="p-font0-8 p-white p-radius20"
							style="color:white;background-color: red;padding: 0.2rem 1rem 0.2rem 1rem;">未达标</span>
					</span>
				</div>
				<div class="p-padding30 " style="padding-top:0 ;margin-top: 0;">
					<span class="p-color4 p-font0-8">{{$t('measure.referenceValue')}}：≥35mmHg </span>
				</div> -->
	
	
	
				<!-- <div style="margin-right: 1rem;">
					<span style="float: right;">
						<span class="p-font0-8 p-white p-radius20"
							style="color:white;background-color: green;padding: 0.3rem 1rem 0.3rem 1rem;">生成完整报告与建议</span>
					</span>
				</div>
				<div style="height:2.5rem;"></div> -->
				<div style="height:1rem;"></div>
			</div>
			<div v-if="!allNibpStatisticsShowAll" style="height:0.5rem;"></div>
	
		</div>
	
		<div style="height:2rem;"></div>
	
	
	</div>
</template>

<script>
	import toggleTime from "../components/toggleTime.vue";
	import pillarNibpReport from "../components/chart/pillarNibpReport.vue";

	import mixins from '@/utils/mixins.js'

	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			toggleTime,
			pillarNibpReport,
		},
	data() {
		return {
			allNibpCompleteStatusShowAll: true,
			allNibpStatusShowAll: true,
			allNibpStatisticsShowAll: true,
			isShowGoToMeasure:true,
			pid: 0,
			vtoken: '',
		}
	},
		methods: {
			switchTabStatus(indexTab) {
				console.log("indexTab: ", indexTab);
				switch (indexTab) {
					case 1:
						this.allNibpCompleteStatusShowAll = !this.allNibpCompleteStatusShowAll;
						break;
					case 2:
						this.allNibpStatusShowAll = !this.allNibpStatusShowAll;
						break;
					case 3:
						this.allNibpStatisticsShowAll = !this.allNibpStatisticsShowAll;
						break;
				}
			},
			getData(){
				this.getNibpReportDetail();
			}

		},
		created() {
			document.title = this.$t('measure.bloodPressureReport')
			this.getData();
		},

	}
</script>

<style scoped>

</style>
